<template>
    <div class="panel__container">
        <channel-list v-if="channel === null" data-locator="channel-list">
            <template v-slot="{ channel }">
                <more-navigation v-slot="scope" title="Manage channel" orientation="horizontal">
                    <li v-if="channel.archived_at" class="dropdown-menu__item">
                        <a href="#" @click.prevent="confirm(REINSTATE_CHANNEL, channel)" data-locator="restore" class="dropdown-menu__link">Reinstate</a>
                    </li>
                    <li v-else class="dropdown-menu__item">
                        <a href="#" @click.prevent="confirm(ARCHIVE_CHANNEL, channel)" data-locator="archive" class="dropdown-menu__link" :class="{ 'disabled' : isSingleActiveChannel }">Archive</a>
                    </li>
                    <li v-if="channel.archived_at" class="dropdown-menu__item">
                        <a href="#" @click.prevent="removeChannel(channel, scope)" data-locator="restore" class="dropdown-menu__link dropdown-menu__link--danger">Delete</a>
                    </li>
                </more-navigation>
            </template>
        </channel-list>

        <confirm ref="confirm" @hidden="cancel" data-locator="confirm">
            <header slot="header" class="confirmation__header">
                <img src="/images/actions/archive/confirm.svg" :alt="`${actionMessage} channel`">
                <h4 class="confirmation__title">{{ actionMessage }} channel</h4>
            </header>
            <template slot="cancel">Back to manage channels</template>
            Are you sure you want to {{ actionMessage }} the channel?
        </confirm>

        <confirm ref="confirmRemoval" :danger="true" @hidden="cancel">
            <h3 slot="title" class="confirmation__title">Delete channel</h3>
            Are you sure you want to remove this channel?
            <template slot="message">This action cannot be undone</template>
            <template slot="confirm">Delete</template>
        </confirm>

    </div>
</template>

<script>
/* global EventBus */
import ChannelList from './ChannelList'
import Confirm from '../../Global/Confirm'
import MoreNavigation from '../../Global/MoreNavigation'
import { ARCHIVE_CHANNEL, REINSTATE_CHANNEL } from '../../../stores/global/actions'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ManageChannels',

    data () {
        return {
            channel: null,
            action: null,
            ARCHIVE_CHANNEL,
            REINSTATE_CHANNEL
        }
    },

    methods: {
        confirmChannelAction (action, channel) {
            this.action = action
            this.channel = channel

            this.$refs.confirm.show(channel.name, () => {
                return this.$store.dispatch(this.action, this.channel).then(() => {
                    this.maybeRedirectOnChannelArchive(this.action)

                    EventBus.$emit('newSnackbar', this.resultMessage)
                })
            })
        },

        maybeRedirectOnChannelArchive (action) {
            if (action === ARCHIVE_CHANNEL && this.currentChannelId === this.channel.id) {
                let redirectTo = this.activeCurrentUserChannels[0]

                if (redirectTo === undefined) {
                    return console.warn('No channels to redirect to...')
                }

                window.location.replace(redirectTo.url)
            }
        },

        confirm (action, channel) {
            if (action === ARCHIVE_CHANNEL && this.isSingleActiveChannel) {
                return
            }

            this.confirmChannelAction(action, channel)
        },

        removeChannel (channel, menu) {
            this.channel = channel

            this.$refs.confirmRemoval.show(channel.name, () => {
                return this.$store.dispatch('removeChannel', channel.id).then(() => {
                    EventBus.$emit('newSnackbar', `Channel ${channel.name} removed`)
                })
            })

            menu.close()
        },

        cancel () {
            this.channel = null
        }
    },

    computed: {
        ...mapState(['channels', 'currentChannelId']),
        ...mapGetters(['activeChannels', 'activeCurrentUserChannels']),
        ...mapState(['channels']),

        isSingleActiveChannel () {
            return this.activeChannels.length === 1
        },

        actionMessage () {
            const lang = {
                [ARCHIVE_CHANNEL]: 'Archive',
                [REINSTATE_CHANNEL]: 'Reinstate'
            }

            return lang[this.action]
        },

        resultMessage () {
            const lang = {
                [ARCHIVE_CHANNEL]: 'archived',
                [REINSTATE_CHANNEL]: 'reinstated'
            }

            return `Channel ${this.channel.name} ${lang[this.action]}`
        }
    },

    components: {
        ChannelList,
        Confirm,
        MoreNavigation
    }
}
</script>
